import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { PersonalData } from './PersonalData';
import { AddressData } from './AddressData';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep7() {
  // Context
  const { step7SubStep, setShowActivationFooter, setShowActivationHeader } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle } = getGlobalMetaTitles();
  const activationPersDataPageTitle = tA11yTranslate('ek_global_meta_title_pers_data').content;
  const activationPersDataAdressPageTitle = tA11yTranslate('ek_global_meta_title_pers_data_address').content;
  const isTranslationReady = keyValueValidation(
    activationPersDataPageTitle,
    'ek_global_meta_title_pers_data'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step7SubStep === 1) {
      return `${globalPageTitle} - ${activationPersDataAdressPageTitle}`
    } else {
      return `${globalPageTitle} - ${activationPersDataPageTitle}`;
    }
  };
  
  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step7SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    setShowActivationFooter(true);
    setShowActivationHeader(true); // NEW
  }, []);

  const renderStep7SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <PersonalData />;
      case 1:
        return <AddressData />;
      default:
        return <PersonalData />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step7SubStep}`} />
      {renderStep7SubSteps(step7SubStep)}
    </>
  );
}

export default ActivationStep7;
